import { newKey, errorText } from './executionAdmin';

export const sameIds = (left, right) => [...left].sort((a, b) => a - b).join(',') === [...right].sort((a, b) => a - b).join(',');
export function requestFor(previous, project, payload, makeKey = newKey) {
  const signature = JSON.stringify({ project, payload });
  return previous && previous.signature === signature ? previous : { signature, key: makeKey() };
}

export const settingsPage = {
  data() { return { settings: null, loading: false, busy: false, failed: false, error: '', notice: '', requestVersion: 0, pendingWrite: null }; },
  computed: {
    projectId() { return this.$STORE.state.userConfig.setProjectId; },
    ready() { return !!this.settings && !this.loading && !this.failed && !this.busy; },
  },
  watch: { projectId() { this.settings = null; this.pendingWrite = null; this.notice = ''; this.resetProject(); this.reset(); this.load(); } },
  created() { this.load(); },
  beforeDestroy() { this.requestVersion += 1; },
  beforeRouteLeave(to, from, next) {
    if (this.busy) return next(false);
    next(!this.dirty || window.confirm('تغییرات ذخیره نشده کنار گذاشته شود؟'));
  },
  methods: {
    fa(value) { return Number(value || 0).toLocaleString('fa-IR'); },
    path(query = {}) {
      const params = new URLSearchParams({ p: this.projectId, ...query });
      return '/core/api/admin/settings/' + this.$options.settingsResource + '/?' + params.toString();
    },
    reset() {},
    resetProject() {},
    async load() {
      const version = ++this.requestVersion;
      const project = this.projectId;
      this.loading = true; this.failed = false; this.error = '';
      try {
        const response = await this.$ApiServiceLayer.get(this.path(this.settingsQuery || {}), '');
        if (version !== this.requestVersion || project !== this.projectId) return;
        if (response.status !== 200) { this.failed = true; this.error = errorText(this.$ApiServiceLayer, response); return; }
        this.settings = response.data;
        this.accept(response.data);
      } catch (err) {
        if (version === this.requestVersion && project === this.projectId) { this.failed = true; this.error = 'ارتباط برقرار نشد. دوباره تلاش کنید.'; }
      } finally { if (version === this.requestVersion) this.loading = false; }
    },
    async saveChange(payload) {
      if (!this.ready) return false;
      const project = this.projectId;
      const version = this.requestVersion;
      const data = { expected_revision: this.settings.revision, ...payload };
      this.pendingWrite = requestFor(this.pendingWrite, project, data);
      const key = this.pendingWrite.key;
      this.busy = true; this.error = ''; this.notice = '';
      try {
        const response = await this.$ApiServiceLayer.post(this.path(), '', { ...data, request_key: key });
        if (project !== this.projectId || version !== this.requestVersion) return false;
        if (response.status !== 200) {
          this.error = errorText(this.$ApiServiceLayer, response);
          if (response.status === 409) this.failed = true;
          return false;
        }
        this.pendingWrite = null; this.notice = 'تغییرات ذخیره شد.';
        this.reset(); await this.load();
        return true;
      } catch (err) {
        if (project === this.projectId && version === this.requestVersion) this.error = 'پاسخ ذخیره دریافت نشد. با تلاش مجدد، تغییر تکراری ثبت نمی‌شود.';
        return false;
      } finally { this.busy = false; }
    },
  },
};
